// @ts-nocheck
import React from "react";
import { Download, FileSpreadsheet, FileText } from "lucide-react";
import { Card, CardContent, Button, showToast } from "@/components/ui";

export const ReportsTab = () => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
    {[
      {
        title: "Sales Summary",
        desc: "Monthly sales and revenue report",
        icon: FileText,
        testid: "report-sales",
      },
      {
        title: "Export CSV",
        desc: "Full catalog and order export",
        icon: FileSpreadsheet,
        testid: "report-csv",
      },
      {
        title: "Download Report",
        desc: "Comprehensive seller performance PDF",
        icon: Download,
        testid: "report-download",
      },
    ].map((r) => (
      <Card key={r.testid}>
        <CardContent className="flex flex-col items-center text-center py-8">
          <div className="p-3 rounded-lg bg-indigo-50 dark:bg-indigo-950 text-indigo-600 dark:text-indigo-400 mb-4">
            <r.icon className="w-6 h-6" />
          </div>
          <p className="text-sm font-semibold text-slate-900 dark:text-slate-100 mb-1">
            {r.title}
          </p>
          <p className="text-xs text-slate-500 dark:text-slate-400 mb-4">
            {r.desc}
          </p>
          <Button
            data-testid={r.testid}
            variant="outline"
            size="sm"
            onClick={() =>
              showToast.info("Download", `${r.title} download started (mock).`)
            }
          >
            <Download className="w-4 h-4" /> Download
          </Button>
        </CardContent>
      </Card>
    ))}
  </div>
);
